import moment from "moment";
const path = require("path");
let timeStemp = moment()
  .add(543, "years")
  .format("DD/MM/YYYY hh:mm:ss", true);
Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item);
};
const WwasteReportPDF = async function (data, carname,AppName) { 
  //let DATA = data;
  let conpany_name = AppName
  let sum = data.reduce((a, b) => a + parseFloat(b["W_W"]), 0);
  let f_day;
  let l_day;
  //   console.log(sum);
  //   console.log(data.length);
  let waste_list = [
    [{
        text: "ลำดับ",
        style: "tableHeader",
        alignment: "center",
        bold: true
      },
      {
        text: "เลขที่ ตช.",
        style: "tableHeader",
        alignment: "center",
        bold: true,
      },
      {
        text: "วันที่เก็บขน",
        style: "tableHeader",
        alignment: "center",
        bold: true,
      },
      {
        text: "แหล่งกำเนิด",
        style: "tableHeader",
        alignment: "center",
        bold: true,
      },
      {
        text: "น้ำหนัก",
        style: "tableHeader",
        alignment: "center",
        bold: true,
      },
    ],
    [{
      colSpan: 5,
      type: "none",
      ul: [{
        columns: [{
            text: "",
            bold: true,
          },
          {
            columns: [{
                text: "น้ำหนักรวม กก.",
                bold: true,
                alignment: "left",
              },
              {
                text: `${delimeter(sum)}`,
                bold: true,
                alignment: "right",
              },
            ],
          },
        ],
      }, ],
    }, ],
  ];
  for (let j = data.length - 1; j >= 0; j--) {
    waste_list.insert(1, [{
        text: j + 1,
        alignment: "center"
      },
      {
        text: data[j].T_ID,
        alignment: "left",
      },
      {
        text: (await newTime(data[j].W_I)) + " น.",
        alignment: "center",
      },
      {
        text: data[j].C_N,
        alignment: "right"
      },
      {
        text: await delimeter(data[j].W_W),
        alignment: "right",
      },
    ]);
    if (j + 1 == 1) {
      f_day = await newTimeN(data[j].W_I);
    } else if (j + 1 == data.length - 1) {
      l_day = await newTimeN(data[j].W_I);
    }
  }
  //console.log("********************************");
  //console.log(waste_list);
  const pdf = {
    //pageSize: 'A4',
    // pageMargins: [ 30, 0, 30, 0 ],
    footer(currentPage, pageCount) {
      return {
        columns: [
          // { text: "ท้ายกระดาษ", fontSize: 15, alignment: "center" },
          {
            text: "หน้าที่ " +
              currentPage.toString() +
              " จาก " +
              pageCount +
              " หน้า",
            margin: [5, 5, 15, 5],
            alignment: "right",
          },
        ],
      };
    },
    // สีพื้นหลัง
    // background: function() {
    //   return {
    //     canvas: [
    //       {
    //         type: "rect",
    //         x: 0,
    //         y: 0,
    //         w: 595.28,
    //         h: 841.89,
    //         color: "#00BFFF",
    //       },
    //     ],
    //   };
    // },
    content: [{
        columns: [{
            image: await getBase64ImageFromURL(
              "https://res.cloudinary.com/dfgnhewbg/image/upload/v1595224134/newchok-icon_tuzsem.png"
            ),
            alignment: "center",
            fit: [50, 50],
            justify: "center",
            width: 20,
            alignment: 'left',
            absolutePosition: {
              x: 40
            }
          },
          {
            text: [{
                text: "รายงานใบ ตช.  ",
                bold: true,
                style: "content",
                margin: [0, 0, 20, 0], //left top right bottom
                alignment: "center",
              },
              {
                text: conpany_name.compnany,
                bold: true,
                style: "content",
                margin: [0, 0, 20, 0], //left top right bottom
                alignment: "center",
              },
              {
                text: `วันที่ ${f_day} น. - ${checkData(l_day)} น. ${checkData(carname)} `,
                bold: true,
                style: "content",
                margin: [0, 0, 20, 0], //left top right bottom
                alignment: "center",
              },
            ],
            width: '*'
          },
        ],
      },

      {
        table: {
          widths: [20, 80, 100, 220, 60],
          body: waste_list,
        },
        margin: [0, 0, 0, 10], //left top right bottom
      },
      {
        text: "วันที่ : _____________________    ",
        bold: true,
        style: "content",
        margin: [0, 0, 20, 0], //left top right bottom
        alignment: "right",
      },
      {
        text: "น้ำหนักหน้าโรงกำจัด : _____________________ กก.",
        bold: true,
        style: "content",

        alignment: "right",
      },
      {
        text: "ลายเซ็น : _____________________    ",
        bold: true,
        style: "content",
        margin: [0, 15, 20, 0], //left top right bottom
        alignment: "right",
      },
    ],
    defaultStyle: {
      font: "THSarabunNew",
    },
    styles: {
      header: {
        fontSize: 18,
        alignment: "center",
        //bold: true
      },
      content: {
        fontSize: 16,
        alignment: "left",
        margin: [0, 10, 0, 0],
      },
      content_8: {
        fontSize: 16,
        alignment: "left",
        margin: [20, 10, 0, 0],
      },
      signature: {
        fontSize: 16,
        alignment: "center",
        margin: [0, 30, 0, 0],
      },
    },
  };
  return pdf;
};

// The "callback" argument is called with either true or false
// // depending on whether the image at "url" exists or not.
// function imageExists(url, callback) {
//   var img = new Image();
//   img.onload = function() { callback(true); };
//   img.onerror = function() { callback(false); };
//   img.src = url;
// }

// // Sample usage
// var imageUrl = 'http://www.google.com/images/srpr/nav_logo14.png';
// imageExists(imageUrl, function(exists) {
//   console.log('RESULT: url=' + imageUrl + ', exists=' + exists);
// });

// create function TH time
async function newDates(data) {
  // console.log(data);
  let a = moment(data)
    .add(543, "years")
    .format("DD/MM/YYYY hh:mm:ss", true);
  return a;
}
async function newTime(data) {
  //console.log(data);

  let a = moment(data)
    .add(543, "years")
    .format("DD/MM/YYYY hh:mm:ss", true);

  return a;
}
async function newTimeN(data) {
  let a = moment(data)
    .add(543, "years")
    .format("DD/MM/YYYY ", true);
  return a;
}

function delimeter(data) {
  let y = parseFloat(data).toFixed(2);
  let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

  return x;
}

function getBase64ImageFromURL(url) {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.setAttribute("crossOrigin", "anonymous");

    img.onload = () => {
      var canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      var ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0);

      var dataURL = canvas.toDataURL("image/png");

      resolve(dataURL);
    };

    img.onerror = (error) => {
      reject(error);
    };

    img.src = url;
  });
}

function checkData(data) {
  if (data) {
    return data
  }else{
    return ''
  }
}
export default WwasteReportPDF;